import React, { Component } from "react";
import { Layout, Menu, Icon } from "antd";
import { removeToken } from "../utils/LoginManager";
import { withRouter, Link } from "react-router-dom";
import LogoNordeste from '../imagens/LogoWeb.png';

const { Sider } = Layout;
const { Item } = Menu;

const MENU_ITENS = [
  {
    url: "/",
    icone: "home",
    titulo: "Home"
  },
  {
    url: "/cotacoes",
    icone: "file-text",
    titulo: "Cotações"
  },
  // {
  //   url: "/tarefas",
  //   icone: "file-text",
  //   titulo: "Tarefas"
  // },
  // {
  //   url: "/sobre",
  //   icone: "info-circle-o",
  //   titulo: "Sobre"
  // }
];

class SideMenu extends Component {
  state = {};

  sair = () => {
    removeToken();
    this.props.history.push("/login");
  };

  renderItems = () => {
    const items = MENU_ITENS.map(item => {
      return (
        <Item key={item.url}>
          <Link to={item.url}>
            <Icon type={item.icone} />
            <span className="nav-text">{item.titulo}</span>
          </Link>
        </Item>
      );
    });
    return items;
  };
  render() {
    return (
      <Sider breakpoint="md" collapsedWidth="0">
        <div>
          {/* <h1>Expresso Nordeste</h1> */}
          <img 
            alt="Expresso Nordeste" 
            src={LogoNordeste} 
            style={{ 
                width: '100%',
                margin: 3,
                paddingBottom: 20,
            }} 
          />
        </div>
        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[this.props.location.pathname]}
        >

          {this.renderItems()}

          <Item>
            <a href="#" onClick={this.sair}>
              <Icon type="logout" />
              <span className="nav-text">Sair</span>
            </a>
          </Item>
        </Menu>
      </Sider>
    );
  }
}

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/layouts/SideMenu.js